import { Button, Group } from "@mantine/core";
import React from "react";
import _ from "lodash";
import AllowanceTerminateButton from "./allowanceTerminateButton";
import AllowanceReactiveButton from "./allowanceReactiveButton";
import ActionPermissionGate from "./actionPermissionGate";

const AllowanceActionList = ({ form }) => {
  const status = _.get(form.values, "status");
  const id = _.get(form.values, "_id");

  return (
    <Group mt={10}>
      {status !== "COMPLETED" && (
        <ActionPermissionGate entity="allowance" action="terminate">
          <AllowanceTerminateButton form={form} id={id} />
        </ActionPermissionGate>
      )}

      {status !== "COMPLETED" && (
        <ActionPermissionGate entity="allowance" action="reactive">
          <AllowanceReactiveButton form={form} id={id} />
        </ActionPermissionGate>
      )}

      {status === "COMPLETED" && (
        <Button variant="outline" fullWidth>
          Completed
        </Button>
      )}
    </Group>
  );
};

export default AllowanceActionList;
